import React from "react";

interface AdminProductStatsHeaderProps {
  totalCount: number;
  basketCount: number;
  portfolioCount: number;
  managedStrategyCount: number;
}

const AdminProductStatsHeader: React.FC<AdminProductStatsHeaderProps> = ({
  totalCount,
  basketCount,
  portfolioCount,
  managedStrategyCount,
}) => {
  return (
    <div className="flex items-center gap-4 mb-4">
      <div className="flex items-center gap-2 bg-rp-surface-raised px-3 py-2 rounded-lg border border-rp-separator">
        <span className="text-[9px] font-black text-rp-grey/50 uppercase">Total</span>
        <span className="text-sm font-bold text-rp-grey">{totalCount}</span>
      </div>
      <div className="flex items-center gap-2 bg-rp-surface-raised px-3 py-2 rounded-lg border border-rp-separator">
        <div className="w-2 h-2 rounded-full bg-blue-500" />
        <span className="text-[9px] font-black text-rp-grey/50 uppercase">Baskets</span>
        <span className="text-sm font-bold text-rp-grey">{basketCount}</span>
      </div>
      <div className="flex items-center gap-2 bg-rp-surface-raised px-3 py-2 rounded-lg border border-rp-separator">
        <div className="w-2 h-2 rounded-full bg-purple-500" />
        <span className="text-[9px] font-black text-rp-grey/50 uppercase">Portfolios</span>
        <span className="text-sm font-bold text-rp-grey">{portfolioCount}</span>
      </div>
      <div className="flex items-center gap-2 bg-rp-surface-raised px-3 py-2 rounded-lg border border-rp-separator">
        <div className="w-2 h-2 rounded-full bg-teal-500" />
        <span className="text-[9px] font-black text-rp-grey/50 uppercase">Managed Strategies</span>
        <span className="text-sm font-bold text-rp-grey">{managedStrategyCount}</span>
      </div>
    </div>
  );
};

export default AdminProductStatsHeader;
